export default function RouteContentFallback() {
  return (
    <div className="route-loading" role="status" aria-live="polite" aria-label="Carregando página">
      <header className="route-loading__header" aria-hidden="true">
        <span className="aden-skeleton route-loading__title" />
        <span className="aden-skeleton route-loading__subtitle" />
      </header>
      <section className="route-loading__metrics" aria-hidden="true">
        {[1, 2, 3, 4].map(item => <span key={item} className="aden-skeleton" />)}
      </section>
      <section className="aden-skeleton route-loading__content" aria-hidden="true" />
      <span className="sr-only">Carregando página…</span>
    </div>
  )
}
